import React, {useContext, useRef} from 'react';
import style from './style';
import EAIcon from "../../../../../components/common/EAIcon";
import EAColorIcon from "../../../../../components/common/EAColorIcon";
import {Grid, TextField, Typography} from "@mui/material";
import i18next from "i18next";
import {Controller, FormProvider, useForm} from "react-hook-form";
import EAButton from "../../../../../components/common/EAButton";
import {getAccountThirdparties} from "../../../../../services/edge/ThirdpartyService";
import {Context} from "../../../../../states/Store";
import {InitialThirdpartiesTableSort} from "../../../../thirdparties/thirdparties-list/ThirdpartiesTableUtils";

const uniqueById = (array, id) => {
  const map = new Map();
  array.forEach(item => map.set(item[id], item));
  return Array.from(map.values());
};

const ThirdPartySearch = ({setFoundTp}) => {
  const {classes} = style();
  const [state] = useContext(Context);
  const abortControllerRef = useRef();

  const [sortModel, ] = React.useState(
    InitialThirdpartiesTableSort
  );
  const formMethods = useForm({
    mode: "onChange",
    delayError: 500,
    defaultValues: {
      denomination: "",
      code: "",
      identifiant: ""
    },
  });

  const {
    control,
    formState: {errors},
    getValues,
  } = formMethods;

  const CompanyIdTypes = ["CIT001", "CIT002", "CIT003"];

  const parseFilters = (formValues) => {
    const {identifiant, code, denomination} = formValues;
    let filters = [];
    if (identifiant) {
      filters = CompanyIdTypes.map((cId) => ({
        companyIdType: cId,
        identifier: identifiant,
        ...(code && {code}),
        ...(denomination && {name: denomination})
      }));
    } else {
      if (denomination || code) {
        filters.push({
          ...(denomination && {name: denomination}),
          ...(code && {code})
        });
      }
    }
    return filters;
  };

  const searchThirdParty = async (e) => {
    e.preventDefault();
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;
    const formValues = getValues();

    const filters = parseFilters(formValues);
    const res = await Promise.all(filters.map(async (filter) =>
      await getAccountThirdparties(
        state.account.id,
        true,
        {page: 0, rowPerPage: 50},
        filter,
        sortModel,
        null,
        signal
      )
    ));
    const filteredRes = uniqueById(
      res.map(r => r.content).filter(r => r.length).flat(),
      'thirdpartyId'
    )
    setFoundTp(filteredRes);
  }

  return <div className={classes.root}>
    <div className={classes.filterBlock}>
      <div className={classes.titleWrapper}>
        <EAColorIcon icon={'/context/addTiers2'} svgStyle={{ position: "relative", top: "3px", marginRight: "5px" }}/>
        <Typography variant={'h3'} className={classes.title}>
          {i18next.t(`context.addTiers.associer`)}
        </Typography>
      </div>
      <div className={classes.searchBy}>
        {i18next.t('context.addTiers.searchBy')}
      </div>
      <FormProvider {...formMethods} className={classes.searchForm}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Controller
              control={control}
              name="denomination"
              render={({field}) => (
                <TextField
                  {...field}
                  className={classes.searchInput}
                  id="denomination-id"
                  variant="outlined"
                  error={!!errors.denomination}
                  placeholder="Dénomination"
                  fullWidth
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      searchThirdParty(e);
                    }
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={2}>
            <Controller
              control={control}
              name="code"
              render={({field}) => (
                <TextField
                  {...field}
                  className={classes.searchInput}
                  id="code-id"
                  variant="outlined"
                  error={!!errors.code}
                  placeholder="Code tiers"
                  fullWidth
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      searchThirdParty(e);
                    }
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <Controller
              control={control}
              name="identifiant"
              render={({field}) => (
                <TextField
                  {...field}
                  className={classes.searchInput}
                  id="identifiant-id"
                  variant="outlined"
                  error={!!errors.identifiant}
                  placeholder="Identifiants"
                  fullWidth
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      searchThirdParty(e);
                    }
                  }}
                />
              )}
            />
          </Grid>
          <Grid item               sx={{ ml: "auto" }}>
            <EAButton
              onClick={searchThirdParty}
              className={classes.searchButton}
              content={<>
                <EAIcon icon={'/context/search'}/>
                <span>{i18next.t(`context.addTiers.search`)}</span>
              </>}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </div>
  </div>
}

export default ThirdPartySearch;